import { render, staticRenderFns } from "./VerEstatisticas.vue?vue&type=template&id=1880954f&scoped=true"
import script from "./VerEstatisticas.vue?vue&type=script&lang=js"
export * from "./VerEstatisticas.vue?vue&type=script&lang=js"
import style0 from "./VerEstatisticas.vue?vue&type=style&index=0&id=1880954f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880954f",
  null
  
)

export default component.exports